import React from "react";
import { Chip, Stack, Typography } from "@mui/material";

export const SelectChip = ({
  value,
  isSelected,
  onClick,
  isRecipeCount = true,
  sx = {}
}) => {
  const count =
    value.recipeCount_template >= 0
      ? value.recipeCount_template
      : value.recipeListCount || 0;

  return count == 0 ? null : (
    <Stack
      sx={{
        flexDirection: "row",
        alignItems: "center",
        borderRadius: "32px",
        gap: "8px",
        border: "1px solid #DFE8F2",
        p: "6px 8px 6px 10px",
        bgcolor: isSelected ? "primary.main" : "transparent",
        color: isSelected ? "#fff" : "inherit",
        minWidth: "fit-content",
        cursor: "pointer",
        height: "32px",
        ...sx
      }}
      onClick={onClick}
    >
      <Typography fontSize="14px" fontWeight={500} noWrap>
        {value.name}
      </Typography>
      {isRecipeCount && (
        <Chip
          size="small"
          sx={{
            fontSize: "12px",
            fontWeight: 500,
            backgroundColor: isSelected ? "primary.dark" : "default",
            color: isSelected ? "#fff" : "inherit",
          }}
          label={count} // Ensure 0 is displayed properly
        />
      )}
    </Stack>
  );
};
